// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

const inBrowser = typeof window !== 'undefined'
if (inBrowser) {
  // import VueResource from 'vue-resource'
  // Vue.use(VueResource)
  Vue.use(require('vue-resource'))
}

// 定义路由配置
import router from './router'

new Vue({
  router: router,
  render: h => h(App)
  // components: { firstcomponent, secondcomponent }
}).$mount('#app_index')

// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   data: {
//     currentRoute: window.location.pathname
//   },
//   computed: {
//     ViewComponent () {
//       console.log(this.currentRoute)
//       return routes[this.currentRoute] || NotFound
//     }
//   },
//   render (h) { return h(this.ViewComponent) }
// })




// WEBPACK FOOTER //
// ./src/main.js